import { render, staticRenderFns } from "./BidSelector.vue?vue&type=template&id=74a66921&scoped=true&"
import script from "./BidSelector.vue?vue&type=script&lang=js&"
export * from "./BidSelector.vue?vue&type=script&lang=js&"
import style0 from "./BidSelector.vue?vue&type=style&index=0&id=74a66921&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a66921",
  null
  
)

export default component.exports